<template>
  <div class="basic_wrap video-page">
    <div class="red_top_bg page-top">
      <div class="big_tit">
        {{ $t('sky.ying') }}
      </div>
    </div>

    <div class="tab-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <van-list
        v-else
        v-model="loading"
        :finished="finished"
        :offset="100"
        :loading-text="$t('pro2.loading')"
        @load="loadVideos"
      >
        <div
          v-if="list.length"
          class="video-grid"
        >
          <article
            v-for="(item, index) in list"
            :key="item.id || index"
            class="movie-list-item"
            @click="$router.push('/vplay/' + item.id)"
          >
            <div class="cover_img">
              <img
                :src="item.pic"
                alt=""
              >
              <div class="movie-time-div">
                <van-icon name="play-circle-o" />
                <span>{{ $t('sky.play') }}: {{ item.pnum }}</span>
              </div>
            </div>
          </article>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
	Empty,
	List,
	Icon,
} from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(List).use(Icon);

export default {
	name: "Vindex",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			data: null,
			loading: false,
			page: 1,
			limit: 12,
			list: [],
			cur: 0,
			type: 0,
			islogin: false,
			finished: false,
			empty: false,
			requestLock: false,
		};
	},
	created() {
		this.$parent.footer("video", true);
	},
	mounted() {
		this.islogin = localStorage.getItem("token") != null;
		if (!this.islogin) {
			this.$router.push("/login");
		}
	},
	methods: {
		loadVideos() {
			if (this.requestLock || this.finished) {
				this.loading = false;
				return;
			}
			this.requestLock = true;
			this.loading = true;
			Fetch("/index/videos", {
				type: this.cur,
				page: this.page,
			}).then(r => {
				this.data = r.data;
				var rows = r.data && r.data.list ? r.data.list : [];

				if (rows.length > 0) {
					this.list = this.list.concat(rows);
					this.page++;
				}
				this.empty = this.list.length === 0;
				this.finished = !(r.data && r.data.has_more);
				this.loading = false;
				this.requestLock = false;
			}).catch(() => {
				this.loading = false;
				this.requestLock = false;
				this.finished = true;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.video-page {
	min-height: 100vh;
	background: #191818;
	color: #f5f1ec;
	padding-bottom: 84px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #191818;
	color: #f5f1ec;
	border-bottom: 1px solid rgba(112, 90, 68, 0.45);
	box-sizing: border-box;

	.big_tit {
		color: #f5f1ec;
	}
}

.tab-content {
	position: relative;
	overflow-y: auto;
	padding-bottom: 84px;
	-webkit-overflow-scrolling: touch;
}

.video-grid {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
	padding: 16px;
}

.movie-list-item {
	min-width: 0;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(128, 101, 74, 0.88);
	background: #292929;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
}

.cover_img {
	position: relative;
	aspect-ratio: 1 / 1.16;
	overflow: hidden;
	background: #1b1a1a;
}

.cover_img img {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
}

.movie-time-div {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	min-height: 34px;
	padding: 0 10px;
	display: flex;
	align-items: center;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.76) 100%);
	color: #ffd0ad;
	font-size: 12px;
	font-weight: 700;
	line-height: 18px;
	box-sizing: border-box;
}

.movie-time-div span {
	min-width: 0;
	margin-left: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description,
/deep/ .van-list__loading,
/deep/ .van-list__finished-text {
	color: #9aa1aa;
}

@media screen and (max-width: 374px) {
	.video-grid {
		gap: 10px;
		padding-right: 12px;
		padding-left: 12px;
	}
}
</style>
